"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlineWatcher = void 0;
function onlineWatcher(logger) {
    const online = (event) => {
        const eventJson = JSON.stringify(event);
        logger.warn("user online", { eventJson });
    };
    const offline = (event) => {
        const eventJson = JSON.stringify(event);
        logger.warn("user offline", { eventJson });
    };
    window.addEventListener("online", online);
    window.addEventListener("offline", offline);
    return () => {
        window.removeEventListener("online", online);
        window.removeEventListener("offline", offline);
    };
}
exports.onlineWatcher = onlineWatcher;
//# sourceMappingURL=online-watcher.js.map